import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { AppDispatch } from '../store';
import type { RootState } from '../reducers';

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAuth = () => useAppSelector((state) => state.auth);
export const useAdmin = () => useAppSelector((state) => state.admin);
export const useStashcard = () => useAppSelector((state) => state.stashcard);

export const useCurrentUser = () => useAppSelector((state) => state.auth.currentUser);
export const useAuthLoading = () => useAppSelector((state) => state.auth.isLoading);
export const useLoginError = () => useAppSelector((state) => state.auth.loginError);

export const useImportInProgress = () => useAppSelector((state) => state.admin.importInProgress);
export const useImportResult = () => useAppSelector((state) => state.admin.importResult);
export const useImportErrors = () => useAppSelector((state) => state.admin.importErrors);

export const useCategories = () => useAppSelector((state) => state.stashcard.categories);
export const useStashcards = () => useAppSelector((state) => state.stashcard.stashcards);
export const useStashcardLoading = () => useAppSelector((state) => state.stashcard.isLoading);
export const useStashcardError = () => useAppSelector((state) => state.stashcard.error);
